<template>
    <div class="section-header">
        <div class="section-header-left">
            <h1 v-html="title" class="header1"></h1>
            <slot name="subTitle">
                <template v-if="subTitle">
                        <template v-if="isSubTitleAction">
                            <a class="header2-link" @click="onSubTitleClick">
                                {{subTitle}}
                                <i class="icon s-icon-arrow-right"/>
                            </a>
                        </template>
                        <template v-else>
                            <h2 class="header2">
                                {{subTitle}}
                            </h2>
                        </template>
                </template>
            </slot>

        </div>
        <div class="section-header-right" v-if="image">
            <img :src="image"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        image: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        subTitleAction: {
            type: [String, Function],
            default: ''
        }
    },
    computed: {
        isSubTitleAction() {
            return !!this.subTitleAction
        }
    },
    methods: {
        onSubTitleClick(e) {
            e.preventDefault()
            if (this.subTitleAction instanceof Function) {
                this.subTitleAction()
            } else {
                window.open(this.subTitleAction, '_blank')
            }
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

$header-right-width = 420px

.section-header
    display flex
    width 100%
    min-height 300px

    .section-header-left
        flex 1 1 auto

        .header1
            margin-bottom 0

        .header2
            margin-top 24px
            margin-bottom 0

        .header2-link
            font-size 20px
            color $color-primary
            font-weight bold
            margin-top 24px
            margin-bottom 0
            cursor pointer
            transition all 0.35s

            .icon
                display inline-block
                font-size 12px
                font-weight normal
                margin-left 12px
                transition all 0.35s

            &:hover
                opacity 0.8

                .icon
                    transform translateX(10px)

    .section-header-right
        flex 1 0 $header-right-width
        width $header-right-width
        position relative

        img
            position absolute
            top -100px
            width $header-right-width
            right 0

    @media screen and (max-width: $mobile-step1-max-width)
        min-height 100px

        .section-header-right
            display none

</style>



// WEBPACK FOOTER //
// src/components/v3/section/SectionHeader.vue